module.exports = __webpack_public_path__ + "img/icon_waku_auto.cca2d544.png";